var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('voucher',{attrs:{"voucher-code":_vm.$router.currentRoute.params.voucherCode}})}
var staticRenderFns = []

export { render, staticRenderFns }